export default __webpack_public_path__ + "static/media/2339.2f60da87.png";